import axios from './../axios';
import { toQuery } from '@/plugins/toQuery';
import { toArrayQuery } from '@/plugins/toQuery';
// import { parseComponent } from 'vue-template-compiler';

export const getOffers = async (arrayFilter, filters) => {
  let arrayParams = toArrayQuery({
    regions: arrayFilter.regions,
    communities: arrayFilter.communities,
    specifications: arrayFilter.specifications
  });

  try {
    const res = await axios.get(`/products?${toQuery(filters)}${arrayParams.length ? `${decodeURIComponent(arrayParams)}` : ''}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};